// @ts-nocheck
import { injectCss } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface SliderBarStylesProps {
    distance?: number | (number | null)[];
    position?: string;
    color?: string;
    height?: Amount;
}

export const sliderBarStyles = ({
    distance = 42,
    position = "top",
    color = "primary",
    height = 3,
}: SliderBarStylesProps) => {
    return css`
        display: block;
        position: absolute;
        ${typeof distance === "number" && `${position}: ${pxToRem(distance)};`}
        ${Array.isArray(distance) && breakpointValues(pxToRemArray(distance), position)}
        height: ${height}px;
        background: ${getColor(color)};
        width: 0;
        transition: width 0.25s ease, height 0.25s linear, left 0.25s ease;
        pointer-events: none;
    `;
};

const StyledNavSliderBar = styled.span<any>`
    ${injectCss}
`;

interface OwnProps {
    currentEvent?: React.ChangeEvent<HTMLInputElement>;
    classIdentifier: string;
}
type Props = OwnProps & SliderBarStylesProps;
export const NavSliderBar: FC<Props> = ({
    children,
    distance = 42,
    position = "top",
    color = "primary",
    height = 3,
    currentEvent,
    classIdentifier,
}) => {
    const [barWidth, setBarWidth] = React.useState(0);
    const [offset, setOffset] = React.useState(0);
    const tempStyles = sliderBarStyles({ distance, position, color, height });
    const [computedStyles, setComputedStyles] = React.useState(tempStyles);

    React.useEffect(() => {
        if (currentEvent) {
            const linkElement = currentEvent.target;
            if (linkElement.classList.contains(classIdentifier)) {
                const linkElementWrapper = linkElement.parentElement;
                const linkElementWrapperOffset = linkElementWrapper?.offsetLeft;
                const linkElementWrapperWidth = linkElementWrapper?.offsetWidth;

                if (linkElementWrapperWidth && linkElementWrapperOffset && currentEvent.type === "mouseover") {
                    activateSlideBar(linkElementWrapperWidth, linkElementWrapperOffset);
                }

                if (currentEvent.type === "mouseleave") {
                    deactivateSlideBar();
                }
            }
        } else {
            deactivateSlideBar();
        }
    }, [currentEvent]);

    const activateSlideBar = (width: number | undefined, offset: number | undefined) => {
        if (width && width > 0) {
            setBarWidth(width);
        }
        if (offset && offset > 0) {
            setOffset(offset);
        }
        setComputedStyles(css`
            ${tempStyles}
            width: ${width}px;
            height: ${height}px;
            left: ${offset}px;
        `);
    };

    const deactivateSlideBar = () => {
        setComputedStyles(css`
            ${tempStyles}
            width: ${barWidth}px;
            height: 0px;
            ${offset && offset > 0 ? `left: ${offset}px;` : ""}
        `);
    };

    return <StyledNavSliderBar css={computedStyles}>{children}</StyledNavSliderBar>;
};

export const StyledSliderBar = styled.span<any>`
    display: block;
    position: relative;
    padding: ${pxToRem(10, 0)};
    line-height: ${pxToRem(17)};

    &:after {
        content: "";
        background-color: ${getColor("primary")};
        height: ${pxToRem(3)};
        width: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: width 0.25s;
    }
    ${injectCss}
`;

// To use on the button/link that includes a SliderBar component
export const sliderBarCss = css`
    position: relative;

    &:hover {
        ${StyledSliderBar} {
            &:after {
                width: 100%;
            }
        }
    }
`;
// To use on the button/link that includes a SliderBar component; for selected effect
export const sliderBarCssActive = css`
    ${StyledSliderBar} {
        &:after {
            width: 100%;
        }
    }
`;

const SliderBar: FC = ({ children }) => {
    return <StyledSliderBar>{children}</StyledSliderBar>;
};

export default SliderBar;
